import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteChallenge = async (
  token: string,
  challengeId: number,
  isDeletedBonus: any
) => {
  try {
    const { data } = await Client.delete(
      `challenge/delete/${challengeId}?isDeletedBonus=${isDeletedBonus}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    posthog.capture('DeletedChallenge', {
      DeletedChallenge: data
    });
    return { data };
  } catch (response) {
    const result = { response } as any;
    return { errors: result.data };
  }
};
